(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["menu-collection-search"] && !Shopify.designMode) return;
  try {
    
  const cache = new WeakMap();

  const compact = (value) =>
    value
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9α-ω]/g, '');

  const getState = (root) => {
    if (cache.has(root)) return cache.get(root);

    const dataEl = root.querySelector('[data-lb-mcs-data]');
    let items = [];
    try {
      items = JSON.parse(dataEl ? dataEl.textContent : '[]');
    } catch (error) {
      items = [];
    }

    const state = {
      items,
      input: root.querySelector('[data-lb-mcs-input]'),
      results: root.querySelector('[data-lb-mcs-results]'),
      clear: root.querySelector('[data-lb-mcs-clear]'),
      status: root.querySelector('[data-lb-mcs-status]'),
      active: -1,
    };
    cache.set(root, state);
    return state;
  };

  const closeResults = (state) => {
    state.active = -1;
    state.results.hidden = true;
    state.results.innerHTML = '';
    state.input.setAttribute('aria-expanded', 'false');
    state.status.textContent = '';
  };

  const setActive = (state, index) => {
    const links = [...state.results.querySelectorAll('[data-lb-mcs-result]')];
    state.active = index;
    links.forEach((link, i) => link.classList.toggle('is-active', i === index));
  };

  const render = (root) => {
    const state = getState(root);
    const query = state.input.value.trim();
    const minChars = Number(state.input.dataset.minChars || 1);
    const limit = Number(state.input.dataset.limit || 8);

    state.clear.hidden = query.length === 0;

    if (query.length < minChars) {
      closeResults(state);
      return;
    }

    const escapeHtml = (value) =>
      String(value || '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');

    const needle = compact(query);
    const matches = state.items
      .filter((item) => compact(item.haystack || item.title || '').includes(needle))
      .slice(0, limit);

    if (matches.length === 0) {
      state.results.hidden = false;
      state.results.innerHTML = `<li><p class="lb-mcs__empty">${escapeHtml(state.input.dataset.empty || '')}</p></li>`;
      state.input.setAttribute('aria-expanded', 'true');
      state.status.textContent = state.input.dataset.empty || '';
      state.active = -1;
      return;
    }

    state.results.hidden = false;
    state.results.innerHTML = matches
      .map(
        (item, index) =>
          `<li><a class="lb-mcs__result" href="${escapeHtml(item.url)}" role="option" data-lb-mcs-result data-index="${index}">${escapeHtml(item.title)}</a></li>`
      )
      .join('');
    state.input.setAttribute('aria-expanded', 'true');
    state.status.textContent = `${matches.length}`;
    setActive(state, 0);
  };

  document.addEventListener('input', (event) => {
    const input = event.target.closest('[data-lb-mcs-input]');
    if (!input) return;
    render(input.closest('[data-lb-mcs]'));
  });

  document.addEventListener('click', (event) => {
    const clear = event.target.closest('[data-lb-mcs-clear]');
    if (clear) {
      const root = clear.closest('[data-lb-mcs]');
      const state = getState(root);
      state.input.value = '';
      state.input.focus();
      render(root);
      return;
    }

    if (!event.target.closest('[data-lb-mcs]')) {
      document.querySelectorAll('[data-lb-mcs]').forEach((root) => closeResults(getState(root)));
    }
  });

  document.addEventListener('keydown', (event) => {
    const input = event.target.closest('[data-lb-mcs-input]');
    if (!input) return;

    const root = input.closest('[data-lb-mcs]');
    const state = getState(root);
    const links = [...state.results.querySelectorAll('[data-lb-mcs-result]')];
    if (state.results.hidden || links.length === 0) return;

    if (event.key === 'ArrowDown') {
      event.preventDefault();
      setActive(state, Math.min(state.active + 1, links.length - 1));
    } else if (event.key === 'ArrowUp') {
      event.preventDefault();
      setActive(state, Math.max(state.active - 1, 0));
    } else if (event.key === 'Enter' && state.active >= 0 && links[state.active]) {
      event.preventDefault();
      window.location.href = links[state.active].href;
    } else if (event.key === 'Escape') {
      closeResults(state);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["menu-model-dropdowns"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('change', (event) => {
    const select = event.target.closest('[data-lb-mmd-select]');
    if (!select || !select.value) return;
    window.location.href = select.value;
  });

  } catch(e) { console.error(e); }
})();
})();
